<template>
    <div>
        <el-dialog custom-class="product-dialog-class" :title="title" :visible.sync="dialogVisible" @close="close" width="600px" :close-on-click-modal="false" append-to-body>
            <div class="money-value-config-box">
                <div class="face-value-row">
                    <el-form ref="form" :rules="rules" :inline="true"  :model="fromData" label-width="80px" size="mini">
                        <el-form-item label="面值" prop="value" >
                            <el-input-number size="mini" v-model="fromData.value" :step="1" :min="1" :precision="0" label="请输入面值"></el-input-number>
                        </el-form-item>
                        <el-form-item label="商品链接" prop="goods_url">
                            <el-input size="mini" v-model="fromData.goods_url" placeholder="请输入商品链接" style="width: 358px;" />
                        </el-form-item>
                        <el-form-item label="商品图片" prop="product_image">
                            <file-upload
                                v-model="fromData.product_image"
                                :upload-url="`${$baseURL}/upload/uploadImage`"
                                :max-size="10"
                                select-button-text="选择图片"
                                tip-text="只能上传jpg/png文件，且不超过2MB"
                                acceptTypes="image/jpg,image/png"
                                @showBigImg="showBigImg">
                            </file-upload>                       
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="close">取 消</el-button>
                <el-button class="dialog-btn" type="primary" size="mini" @click="sure" :disabled="loading">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="dialogBigImg.visible" width="600px" append-to-body @close="closeBigImg">
            <div class="dialog-img-box">
                <el-image width="100%" :src="moneyValue.dialogImageUrl" fit="contain"></el-image>
            </div>            
        </el-dialog>
    </div>
</template>
<script>

import FileUpload from './upload.vue'
    export default { 
        name:'MoneyValueConfig',
        components:{
            FileUpload
        },
        props:{
            title:{
                type: String,
                default: ''
            },
            dialogVisible:{
                type: Boolean,
                default:false
            },
            loading:{
                type: Boolean,
                default: false
            },

            // label:
            fromData:{
                type: Object,
                default: function () {
                    return {}
                }
            },
            type:{
                type: String,
                default: ''
            },
            editIndex:{
                type: Number,
                default: -1
            }
        },
        data() {
            return {
                // fromData:{
                //     value: '',
                //     goods_url: '',
                //     product_image:''
                // },
                moneyValue:{
                    dialogImageUrl: '',
                },
                dialogBigImg:{
                    visible: false
                },
                rules:{
                    value:[{ required: true, message: '请输入面值', trigger: 'blur' }],                  
                    goods_url:[{ required: true, message: '请输入商品链接', trigger: 'blur' }],          
                    product_image:[{ required: true, message: '请选择图片', trigger: 'blur' }]        
                },
            }
        },
        mounted(){
        },
        methods: {
            closeBigImg(){
                this.moneyValue.dialogImageUrl = '';
                this.dialogBigImg.visible= false;
            },
            showBigImg(image_url){
                this.moneyValue.dialogImageUrl = image_url;
                this.dialogBigImg.visible= true;
            },
            deleteFaceValue(){
                this.$emit('deleteFaceValue',this.faceIndex)
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePictureCardPreview(file) {
                this.moneyValue.dialogImageUrl = file.url;
                this.dialogBigImg.visible = true;
            },
            close(){
                this.$emit('close');
            },
            sure(){
                // this.fromData.product_image = this.fromData.product_image[0]
                console.log('this.fromData=',this.fromData)
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        // //新增卡包
                        // if(this.type == 'add'){
                        //     this.$emit('sure',this.fromData);
                        // }else{
                            
                        this.$emit('sure',this.fromData,this.editIndex);
                        // }                                  
                    } else {
                        return false;
                    }
                });
                // this.$emit('sure',this.fromData)
            }
        }

    }
</script>

<style lang="scss" scoped>
.money-value-config-box{
    .face-value-row{
        display: flex;
        align-items: flex-end;
        gap: 16px;
        padding: 16px;
        border: 1px solid #e4e7ed;
        border-radius: 6px;
        background-color: #fafcff;
        .delete-btn{
            margin-top: 4px;
            height: 24px;
            width: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
.dialog-img-box{
    width: 100%;
    padding: 10px;
    height: 580px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;

}
</style>